




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'
import { filter, IterateeShorthand } from 'lodash'
import { DueTask, Process, TaskLog } from '@/store/workflow/types'

import AuthorizationMixin from '@/routing/AuthorizationMixin'
import AssessmentMixin from '@/views/assessments/AssessmentMixin'
import PtsdMixin from '../treatment/ptsd/PtsdMixin'
import Measures from '@/survey/Measures.vue'
import ScalingFirst from '@/survey/measures/scaling/Scaling_First.vue'
import EurohisCounseling from '@/survey/measures/eurohis/Eurohis_Counseling.vue'

export default mixins(AuthorizationMixin, AssessmentMixin, PtsdMixin).extend({
  components: {
    Measures,
    EurohisCounseling,
    ScalingFirst,
  },
  computed: {
    ...mapGetters('workflow', ['isDone']),
    patient(): any {
      return this.$store.getters.currentCase.patient
    },
    genderOfPatient(): string | null {
      const patient = this.patient
      return patient.gender && patient.gender.toLowerCase()
    },
    nameOfPatient(): string | null {
      const patient = this.patient
      return patient.alias
    },
    genderOfTherapist(): string | null {
      const therapists: any[] = this.$store.getters.currentCase.members.filter(
        o => o.acts_as_therapist
      )
      return therapists.length > 0 && therapists[0].gender && therapists[0].gender.toLowerCase()
    },
  },
  data() {
    const inTwoDays = new Date()
    inTwoDays.setDate(inTwoDays.getDate() + 2)
    return {
      daysUntilP5: inTwoDays,
      addresseeOfP5: null,
    }
  },
  methods:{
    noActiveTask(process: Process): boolean {
      let tasks: DueTask[] = this.$store.getters['workflow/dueTasks']
      const filters: IterateeShorthand<TaskLog> = {}
      filters.process_instance_id = process.id
      tasks = filter(tasks, filters)
      return tasks.length == 0
    },
  },
})
